module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "value": _vm.progressValue,
      "height": "10",
      "info": ""
    }
  }), _vm._v(" "), (!_vm.transitioning && !_vm.currentConflict.remainingProblems) ? _c('v-card', [_c('v-card-title', [_vm._v("\n        Great. We have no open Conflicts!\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.currentConflict.remainingProblems && !_vm.transitioning) ? _c('v-card', [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.currentConflict.description) + "\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panel', _vm._l((_vm.currentConflict.possibleSolutions), function(solution, index) {
    return _c('v-expansion-panel-content', {
      key: index,
      attrs: {
        "value": index === 0
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.solutionClick(solution)
        }
      },
      slot: "header"
    }, [_vm._v(_vm._s(solution.title))]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
      staticClass: "grey darken-2"
    }, [_c('p', [_vm._v("\n                    " + _vm._s(solution.description) + "\n                  ")]), _vm._v(" "), (solution.choices.length) ? _c('v-select', {
      staticClass: "grey-lighten-3",
      attrs: {
        "options": solution.choices
      },
      model: {
        value: (_vm.currentSolution.choice),
        callback: function($$v) {
          _vm.currentSolution.choice = $$v
        },
        expression: "currentSolution.choice"
      }
    }) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('v-btn', {
    attrs: {
      "secondary": ""
    },
    on: {
      "click": _vm.skipConflict
    }
  }, [_vm._v("Skip")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.currentConflict.loading,
      "disabled": _vm.currentConflict.loading,
      "success": ""
    },
    on: {
      "click": _vm.solveConflict
    }
  }, [_vm._v("Solve")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "error": "",
      "dismissible": "",
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.hasErrors),
      callback: function($$v) {
        _vm.hasErrors = $$v
      },
      expression: "hasErrors"
    }
  }, [_vm._v(_vm._s(_vm.errorDescription))])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2008dd2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conflicts.vue
// module id = 47
// module chunks = 1